var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createContext } from 'react';
import { billingAddressCountries } from './billingAddressCountries';
import { PaymentMethodTypes, } from '../common/props';
import { getYear, format, isSameDay } from 'date-fns';
import { SECONDARY_BADGE_SINGLE_LINE_DESKTOP, SECONDARY_BADGE_SINGLE_LINE_MOBILE, SECONDARY_BADGE_TWO_LINES, } from '../components/ProductCard/ProductCard';
import algoliasearch from 'algoliasearch';
const PHONE_LENGTH = 10;
export const updatedPasswordSuccessMessage = 'Your password has been updated';
export const communicationPreferenceUpdateSuccessMessage = 'Your marketing preferences have been updated successfully';
export const errorMessages = (value) => ({
    minChars: `Please enter more than ${value} characters`,
    maxChars: `${value} character limit exceeded`,
    required: value !== null && value !== void 0 ? value : `This field is required`,
    email: `Please enter a valid email address`,
    minNumber: `${value} is the minimum number`,
    maxNumber: `${value} is the maximum number`,
    date: `Please enter a valid date format`,
    phone: `Please enter only numbers and spaces, it can start with + for international numbers`,
    unsupportedCharacters: 'Sorry, you have entered text that appears to contain some invalid characters, remove those characters and try again',
    minPrice: `${value} is the minimum price to enter`,
    maxPrice: `${value} is the maximum price to enter`,
});
/* Regex to test against the extended ASCII character set */
export const inputValidationRegex = /^[\x20-\xFF\r\n]*$/;
export const cardMessageValidationRegEx = /^[\x20-\xFF\u0041-\u005A\u0061-\u2026\u007A\u2018\u2019\u201C\u201D\u00AA\u02DB\u02ED\u02EF\u02C2\u02C3\u02C4\u02C5\u02C6\u02D2\u02D3\u02D6\u02F4\u02F5\u02F6\u02F7\u02F8\u02D7\u02DD\u02DC\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\r\n]*$/;
export const addressFields = ['addressLine1', 'addressLine2', 'addressLine3', 'city', 'county', 'postalCode', 'country'];
export const ucFirst = (text) => {
    return (text === null || text === void 0 ? void 0 : text.charAt(0).toUpperCase()) + (text === null || text === void 0 ? void 0 : text.slice(1));
};
export const trimPhoneSpace = (e) => {
    if (e.target.value.length >= PHONE_LENGTH) {
        e.target.value = e.target.value.trim();
    }
};
export const partialPrice = (formatted, decimals = 2) => formatted.replace('.' + '0'.repeat(decimals), '');
export const currencyFormat = (number, currency = 'GBP', locale = 'en-GB') => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(number);
export const currencyFormatPartial = (number, decimals = 2, currency = 'GBP') => partialPrice(currencyFormat(number, currency), decimals);
export const priceFormat = (price) => price.centAmount
    ? currencyFormat(price.centAmount / Math.pow(10, price.fractionDigits), price.currencyCode)
    : price.formatted || '';
export const priceFormatPartial = (price) => price ? partialPrice(priceFormat(price), price.fractionDigits) : '';
export const showValidationMeta = (meta) => {
    if (meta.touched && meta.error) {
        return { state: 'error', errorMessage: meta.error };
    }
    else if (meta.touched) {
        return { state: 'success' };
    }
    return {};
};
/* Replace values througout an object based on a test */
export const replacer = (object, test, replace) => {
    const result = {};
    object &&
        Object.keys(object).forEach((key) => (result[key] = test(key, object[key])
            ? replace(key, object[key])
            : object[key] instanceof Array
                ? object[key].map((item) => 
                // only check array contents if contains sub array or objects, i.e. dont check further on an array of strings
                item instanceof Array || typeof item === 'object' ? replacer(item, test, replace) : item)
                : typeof object[key] === 'object' && object[key] !== null
                    ? replacer(object[key], test, replace)
                    : object[key]));
    return result;
};
/* Replace country codes with country names throughout an object */
export const replaceCountryCodes = (object) => replacer(object, (key, value) => key === 'country' && value, (key, value) => {
    const countryLookup = billingAddressCountries.find((country) => country.codeAlpha2 === value);
    const result = countryLookup ? countryLookup.name : value;
    return result;
});
/* Replace country names with country codes throughout an object */
export const replaceCountryNames = (object) => replacer(object, (key, value) => key === 'country' && value, (key, value) => {
    const countryLookup = billingAddressCountries.find((country) => country.name === value);
    const result = countryLookup ? countryLookup.codeAlpha2 : value;
    return result;
});
export const getCountryFromAlpha2Code = (code) => billingAddressCountries.find((country) => country.codeAlpha2 === code);
export const getCountryFromAlpha3Code = (code) => billingAddressCountries.find((country) => country.codeAlpha3 === code);
export const getAttribute = (name, attributes) => { var _a; return ((_a = attributes === null || attributes === void 0 ? void 0 : attributes.find((attr) => attr.name === name)) === null || _a === void 0 ? void 0 : _a.value) || undefined; };
export const hasMultipleAttribute = (variants, attribute) => variants && (variants === null || variants === void 0 ? void 0 : variants.length) > 1 && new Set(variants.map((v) => getAttribute(attribute, v.attributes))).size > 1;
export const decodeQueryParam = (qs) => decodeURIComponent(qs.replace(/\+/g, ' '));
export const validateAllErrorsForSchema = (schema) => (values) => __awaiter(void 0, void 0, void 0, function* () {
    return schema
        .validate(values, {
        abortEarly: false,
        strict: false,
    })
        .then(() => ({}))
        .catch(({ inner }) => {
        return inner.reduce((memo, { path, message }) => (Object.assign(Object.assign({}, memo), { [path]: (memo[path] || []).concat(message) })), {});
    });
});
export const guidedNavigationFilters = ['rotation', 'specialIndicator', 'sameDay', 'daysAvailable'];
export const SiteContext = createContext({});
export var AddToCartErrors;
(function (AddToCartErrors) {
    AddToCartErrors["NO_FLORIST_AVAILABLE"] = "NO_FLORIST_AVAILABLE";
    AddToCartErrors["TOO_MANY_ITEMS_IN_CONSIGNMENT"] = "TOO_MANY_ITEMS_IN_CONSIGNMENT";
})(AddToCartErrors || (AddToCartErrors = {}));
export var SiteKeys;
(function (SiteKeys) {
    SiteKeys["UNITED_KINDOM"] = "interflora-co-uk";
    SiteKeys["IRELAND"] = "interflora-ie";
})(SiteKeys || (SiteKeys = {}));
export var CountryCodes;
(function (CountryCodes) {
    CountryCodes["UNITED_KINDOM"] = "GB";
    CountryCodes["IRELAND"] = "IE";
})(CountryCodes || (CountryCodes = {}));
export const ExperianAltDatasetMapping = {
    [CountryCodes.IRELAND]: 'Eircode',
};
export const algoliaBlogArticleMapping = (hits) => {
    return hits.map((hit) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            title: (_a = hit.data) === null || _a === void 0 ? void 0 : _a.title,
            image: (_b = hit.data) === null || _b === void 0 ? void 0 : _b.image,
            categories: (_c = hit.data) === null || _c === void 0 ? void 0 : _c.categories,
            date: (_d = hit.data) === null || _d === void 0 ? void 0 : _d.date,
            description: (_e = hit.data) === null || _e === void 0 ? void 0 : _e.description,
            link: (_f = hit.data) === null || _f === void 0 ? void 0 : _f.link,
            backgroundColor: (_g = hit.data) === null || _g === void 0 ? void 0 : _g.backgroundColor,
        });
    });
};
export const convertCategoryNames = (names) => (names === null || names === void 0 ? void 0 : names.slice(0, 5).reduce((acc, name, index) => (Object.assign(Object.assign({}, acc), { [`item_category${index ? index + 1 : ''}`]: name })), {})) ||
    {};
export const filterAttributeNameMapping = (isFlyingFlowers) => {
    const filterAttributeNameMappingForFF = new Map([
        ['sortBy', 'Sort by:'],
        ['arrangementType', 'Arrangement type'],
        ['containsAlcohol', 'Contains alcohol'],
        ['deliveryTypes', 'Delivery type'],
        ['flowerColor', 'Colour'],
        ['flowerName', 'Content'],
        ['occasions', 'Occasion'],
        ['productTypeIdentifiers', 'Product type'],
        ['price', 'Price'],
    ]);
    return !isFlyingFlowers
        ? filterAttributeNameMappingForFF.set('style', 'Product style')
        : filterAttributeNameMappingForFF;
};
export const addressBookFields = [
    'firstName',
    'lastName',
    'phone',
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'city',
    'county',
    'postalCode',
    'country',
    'deliveryInstructionNote',
    'deliveryInstructionOption',
];
export const convertDateFormat = (date) => {
    var _a;
    const splitDate = (_a = date === null || date === void 0 ? void 0 : date.toString()) === null || _a === void 0 ? void 0 : _a.split('-');
    const year = parseInt(splitDate[0]);
    const month = parseInt(splitDate[1]) - 1;
    const day = parseInt(splitDate[2]);
    return new Date(year, month, day);
};
const getCharLengthInUTF8 = (ch) => {
    return encodeURIComponent(ch).replace(/%[A-F\d]{2}/g, 'U').length;
};
const UTF8OperationOnString = (message, charOperation, initialValue) => {
    return Array.from(message).reduce(charOperation, initialValue);
};
export const calculateTextLength = (message) => {
    return UTF8OperationOnString(message, function (length, currentChar) {
        return length + getCharLengthInUTF8(currentChar);
    }, 0);
};
export const removeSessionItems = (removeItems) => {
    if (typeof removeItems === 'object') {
        removeItems.forEach((item) => sessionStorage.removeItem(item));
    }
    else
        sessionStorage.removeItem(removeItems);
    return;
};
export const getFilterAttribute = (attrName) => {
    var _a;
    const sessionFiltersList = sessionStorage.getItem('sessionFilters');
    let filter;
    if (!!sessionFiltersList) {
        const parseFilters = JSON.parse(sessionFiltersList);
        filter = !!parseFilters && !!((_a = parseFilters[attrName]) === null || _a === void 0 ? void 0 : _a.length) ? parseFilters[attrName] : undefined;
        if (attrName === 'price') {
            filter = filter === null || filter === void 0 ? void 0 : filter.match(/\d+/g);
            filter = !!filter && (filter === null || filter === void 0 ? void 0 : filter.length) === 1 ? filter + ':' : !!filter && (filter === null || filter === void 0 ? void 0 : filter.length) > 1 ? filter === null || filter === void 0 ? void 0 : filter.join(':') : '';
        }
    }
    return filter;
};
export const getDefaultSortRefienment = (defaultRefinement) => {
    const sessionFiltersList = sessionStorage.getItem('sessionFilters');
    let defaultSort = defaultRefinement;
    const parseFilters = !!sessionFiltersList ? JSON.parse(sessionFiltersList) : undefined;
    if (!!parseFilters && !!parseFilters['sortBy']) {
        defaultSort = parseFilters['sortBy'];
    }
    return defaultSort;
};
export const updateQueryStringParameter = (uri, key, value) => {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
    }
    else {
        return uri + separator + key + '=' + value;
    }
};
/** secondary badge - calulate screen width and split items per row */
export const handleSecondaryBadgeHeight = (isDestop, isTablet, isFromSearchCard) => {
    var _a, _b, _c;
    let device = 'SMALL', split = 1;
    if (window.screen.width <= 320) {
        split = isFromSearchCard ? 2 : 1;
        device = 'SMALL';
    }
    if (window.screen.width > 320 && window.screen.width < 720) {
        split = isFromSearchCard ? 2 : 1;
        device = 'MOBILE';
    }
    if (window.screen.width >= 720 && window.screen.width < 1024) {
        if (navigator.userAgent.includes('Mac') && 'ontouchend' in document && ((_a = window === null || window === void 0 ? void 0 : window.screen) === null || _a === void 0 ? void 0 : _a.width) === 810 && isDestop)
            split = isFromSearchCard ? 4 : 3;
        else if (navigator.userAgent.includes('Mac') &&
            'ontouchend' in document &&
            ((_b = window === null || window === void 0 ? void 0 : window.screen) === null || _b === void 0 ? void 0 : _b.width) === 768 &&
            isTablet &&
            isDestop)
            split = isFromSearchCard ? 4 : 3;
        else
            split = isFromSearchCard ? 3 : 2;
        device = 'TABLET';
    }
    if (window.screen.width >= 1024 && window.screen.width < 1280) {
        if (navigator.userAgent.includes('Mac') &&
            'ontouchend' in document &&
            ((_c = window === null || window === void 0 ? void 0 : window.screen) === null || _c === void 0 ? void 0 : _c.width) === 1024 &&
            isDestop &&
            !isTablet) {
            split = isFromSearchCard ? 5 : 4;
        }
        else
            split = isFromSearchCard ? 5 : 3;
        device = 'DESKTOP';
    }
    if (window.screen.width >= 1280) {
        split = isFromSearchCard ? 5 : 4;
        device = 'LARGEDESKTOP';
    }
    return { device, split, screenWidthVal: window.screen.width };
};
export const checkoutSteps = [
    { heading: 'Your contact information' },
    { heading: 'Billing details' },
    { heading: 'Payment' },
];
export const formatAddEditOccasionValues = (values, isEdit) => {
    const { firstName, lastName, occasion, day, month, id } = values;
    const year = getYear(new Date());
    const finalValues = {
        id,
        firstName,
        lastName,
        occasion,
        date: `${year}-${month}-${day}`,
    };
    return isEdit ? finalValues : { occasionReminders: [finalValues] };
};
export const prepareNDigitArray = (length) => {
    const arr = Array.from({ length: length }, (_, index) => index + 1);
    const response = arr.map((val) => {
        const dateVal = val < 10 ? `0${val}` : `${val}`;
        return { value: dateVal, label: `${val}` };
    });
    return response;
};
export const isMobileDevice = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent)) {
        return true;
    }
    else {
        return false;
    }
};
export const calculateCarouselDotsPosition = (screenWidth, maxLength) => {
    let heightValue = 76;
    const singleLineValue = 68;
    const twoLinesValues = 92;
    const threeLinesValues = 116;
    if (screenWidth <= 360) {
        if (maxLength > 64)
            heightValue = threeLinesValues; // 3 lines
        if (maxLength > 33 && maxLength <= 64)
            heightValue = twoLinesValues; // 2 lines
        if (maxLength <= 33)
            heightValue = screenWidth;
    }
    if (screenWidth > 360 && screenWidth <= 768) {
        if (maxLength > 73)
            heightValue = 92; // 3 lines
        if (screenWidth > 600 && screenWidth <= 736 && maxLength < 70)
            heightValue = singleLineValue;
        if (screenWidth > 600 && screenWidth <= 736 && maxLength > 70)
            heightValue = twoLinesValues;
        if (window.matchMedia('(orientation: landscape)').matches) {
            if ((screenWidth === 390 || screenWidth === 375) && maxLength > 48)
                heightValue = threeLinesValues;
            if ((screenWidth === 390 || screenWidth === 375) && maxLength <= 48)
                heightValue = twoLinesValues; //1 line
            if (screenWidth === 414 && maxLength >= 48)
                heightValue = threeLinesValues; //3 lines
            if (screenWidth === 414 && maxLength < 48)
                heightValue = twoLinesValues; //2 lines
        }
        else {
            if ((screenWidth === 390 || screenWidth === 375) && maxLength >= 67)
                heightValue = threeLinesValues; // 3 lines
            if ((screenWidth === 390 || screenWidth === 375) && maxLength > 37 && maxLength < 67)
                heightValue = twoLinesValues; // 2 lines
            if ((screenWidth === 390 || screenWidth === 375) && maxLength <= 37)
                heightValue = singleLineValue; //1 line
            if ((screenWidth === 428 || screenWidth === 414) && maxLength > 40)
                heightValue = twoLinesValues; // 2 lines
            if ((screenWidth === 428 || screenWidth === 414) && maxLength <= 40)
                heightValue = singleLineValue; // 1 line
            if (screenWidth === 384 && maxLength > 68)
                heightValue = threeLinesValues; // 3 lines
            if ((screenWidth === 384 || screenWidth === 412) && maxLength > 39 && maxLength < 68)
                heightValue = twoLinesValues; // 2 lines
            if ((screenWidth === 384 || screenWidth === 412) && maxLength <= 39)
                heightValue = singleLineValue; // single line
        }
    }
    if (screenWidth > 768 && maxLength <= 55) {
        heightValue = 90;
    }
    return heightValue;
};
export const updateDeliveryInstructionNote = (deliveryInstructionNote, deliveryInstructionOption) => {
    var _a, _b, _c;
    const regularExprestion = new RegExp('-', 'g');
    const count = ((_a = deliveryInstructionNote === null || deliveryInstructionNote === void 0 ? void 0 : deliveryInstructionNote.match(regularExprestion)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const instructionNote = deliveryInstructionNote.split('-');
    if (deliveryInstructionOption !== 'other' &&
        ((_b = instructionNote[0]) === null || _b === void 0 ? void 0 : _b.trim()) === deliveryInstructionOption &&
        count <= 1 &&
        !((_c = instructionNote[1]) === null || _c === void 0 ? void 0 : _c.trim().length)) {
        deliveryInstructionNote = '';
    }
    return replaceThreeDots(deliveryInstructionNote);
};
export const filterSelectedDates = (date, isFlyingFlowers, bankHolidays, availableSundays, deliverySettings) => {
    const weekDay = format(date, 'EEEE'); // returns week days eg: Sunday, Monday ,..
    const londonTime = Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', timeStyle: 'short' }).format(Date.now());
    const isSunday = weekDay === 'Sunday' && !(availableSundays === null || availableSundays === void 0 ? void 0 : availableSundays.includes(format(date, 'yyyy-MM-dd')));
    const isBankHoliday = !!(bankHolidays === null || bankHolidays === void 0 ? void 0 : bankHolidays.includes(format(date, 'yyyy-MM-dd')));
    const isSameDayCheck = isFlyingFlowers
        ? isSameDay(date, new Date())
        : isSameDay(date, new Date()) && !!deliverySettings && deliverySettings.sameDayCutoff < londonTime;
    return isSunday || isBankHoliday || isSameDayCheck;
};
export const calculateSecondaryBadgeOfSimpleCard = (device, heightOfBadge) => {
    let badgeHeight = heightOfBadge;
    if (device === 'LARGEDESKTOP' && badgeHeight) {
        if (badgeHeight <= 21)
            badgeHeight = 26;
        else if (badgeHeight > 21 && badgeHeight <= 40)
            badgeHeight = 46;
        else
            badgeHeight = 66;
    }
    if (device === 'DESKTOP') {
        if (badgeHeight <= 13)
            badgeHeight = 26;
        else if (badgeHeight > 13 && badgeHeight <= 22)
            badgeHeight = 46;
        else
            badgeHeight = 66;
    }
    if (device === 'TABLET') {
        if (badgeHeight <= 12)
            badgeHeight = 26;
        else if (badgeHeight > 12 && badgeHeight <= 22)
            badgeHeight = 46;
        else if (badgeHeight > 22 && badgeHeight <= 31)
            badgeHeight = 66;
        else
            badgeHeight = 86;
    }
    if (device === 'MOBILE') {
        if (badgeHeight <= 13)
            badgeHeight = 26;
        else if (badgeHeight > 13 && badgeHeight <= 22)
            badgeHeight = 46;
        else if (badgeHeight > 22 && badgeHeight <= 38)
            badgeHeight = 66;
        else
            badgeHeight = 86 + 4;
    }
    if (device === 'SMALL') {
        if (badgeHeight <= 11)
            badgeHeight = 26;
        else if (badgeHeight > 11 && badgeHeight <= 16)
            badgeHeight = 46;
        else if (badgeHeight > 16 && badgeHeight <= 24)
            badgeHeight = 66;
        else
            badgeHeight = 86;
    }
    return badgeHeight + 4;
};
export const calculatePLPCardSecondaryBadgeHeight = (device, lengthOfTtile) => {
    var _a, _b, _c, _d, _e;
    if (device === 'DESKTOP') {
        if (((_a = window === null || window === void 0 ? void 0 : window.screen) === null || _a === void 0 ? void 0 : _a.width) >= 1205 && ((_b = window === null || window === void 0 ? void 0 : window.screen) === null || _b === void 0 ? void 0 : _b.width) < 1220) {
            if (lengthOfTtile && lengthOfTtile > 22)
                lengthOfTtile = SECONDARY_BADGE_TWO_LINES;
            else
                lengthOfTtile = SECONDARY_BADGE_SINGLE_LINE_DESKTOP;
        }
        else if (lengthOfTtile && lengthOfTtile >= 20)
            lengthOfTtile = SECONDARY_BADGE_TWO_LINES;
        else
            lengthOfTtile = SECONDARY_BADGE_SINGLE_LINE_DESKTOP;
    }
    if (device === 'LARGEDESKTOP') {
        if (window.screen.width >= 1280 && window.screen.width < 1453 && lengthOfTtile && lengthOfTtile > 19) {
            lengthOfTtile = SECONDARY_BADGE_TWO_LINES;
        }
        else if (lengthOfTtile && lengthOfTtile > 20 && window.screen.width >= 1453) {
            lengthOfTtile = SECONDARY_BADGE_TWO_LINES;
        }
        else if (lengthOfTtile && lengthOfTtile <= 20)
            lengthOfTtile = SECONDARY_BADGE_SINGLE_LINE_DESKTOP;
    }
    if (device === 'TABLET') {
        if (((((_c = window === null || window === void 0 ? void 0 : window.screen) === null || _c === void 0 ? void 0 : _c.width) === 810 && lengthOfTtile && lengthOfTtile > 19) ||
            ((((_d = window === null || window === void 0 ? void 0 : window.screen) === null || _d === void 0 ? void 0 : _d.width) === 769 || ((_e = window === null || window === void 0 ? void 0 : window.screen) === null || _e === void 0 ? void 0 : _e.width) === 768) && lengthOfTtile && lengthOfTtile > 18)) &&
            navigator.userAgent.includes('Mac') &&
            'ontouchend' in document) {
            lengthOfTtile = SECONDARY_BADGE_TWO_LINES;
        }
        else if (lengthOfTtile && lengthOfTtile > 29)
            lengthOfTtile = SECONDARY_BADGE_SINGLE_LINE_MOBILE + 24;
        else
            lengthOfTtile = SECONDARY_BADGE_SINGLE_LINE_MOBILE;
    }
    if (device === 'MOBILE') {
        if (lengthOfTtile && lengthOfTtile > 28)
            lengthOfTtile = 54;
        else
            lengthOfTtile = SECONDARY_BADGE_SINGLE_LINE_MOBILE;
    }
    if (device === 'SMALL') {
        if (lengthOfTtile && lengthOfTtile > 20)
            lengthOfTtile = 54;
        else
            lengthOfTtile = SECONDARY_BADGE_SINGLE_LINE_MOBILE;
    }
    const marginBottomValue = device === 'SMALL' || device === 'MOBILE' || device === 'TABLET' ? 14 : 20;
    return lengthOfTtile + marginBottomValue;
};
export const calculateSearchCardSecondaryBadge = (device, heightOfBadge) => {
    let badgeHeight = heightOfBadge;
    const isMac = navigator.userAgent.includes('Mac') && 'ontouchend' in document;
    if (device === 'LARGEDESKTOP' && badgeHeight) {
        if (badgeHeight <= 19)
            badgeHeight = 26;
        else if (badgeHeight > 19 && badgeHeight <= 39)
            badgeHeight = 46;
        else
            badgeHeight = 66;
    }
    if (device === 'DESKTOP') {
        if (window.screen.width >= 1024 && window.screen.width <= 1196) {
            if (badgeHeight <= 12)
                badgeHeight = 26;
            else if (badgeHeight > 12 && badgeHeight <= 22)
                badgeHeight = 46;
            else if (badgeHeight > 22 && badgeHeight <= 33)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
        else if (window.screen.width > 1196 && window.screen.width < 1289) {
            if (badgeHeight <= 14)
                badgeHeight = 26;
            else if (badgeHeight > 14 && badgeHeight <= 29)
                badgeHeight = 46;
            else if (badgeHeight > 29 && badgeHeight <= 43)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
    }
    if (device === 'TABLET') {
        if (screen.width === 820 && isMac) {
            if (badgeHeight <= 14)
                badgeHeight = 26;
            if (badgeHeight > 14 && badgeHeight <= 29)
                badgeHeight = 46;
            else if (badgeHeight > 29 && badgeHeight <= 32)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
        else if (screen.width === 768 && isMac) {
            if (badgeHeight <= 12)
                badgeHeight = 26;
            if (badgeHeight > 12 && badgeHeight <= 20)
                badgeHeight = 46;
            else if (badgeHeight > 20 && badgeHeight <= 42)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
        else {
            if ((screen.width >= 985 && screen.width < 1024) || (screen.width >= 902 && screen.width < 951)) {
                if (badgeHeight <= 19)
                    badgeHeight = 26;
                else if (badgeHeight > 19 && badgeHeight <= 39)
                    badgeHeight = 46;
                else
                    badgeHeight = 66;
            }
            else if (screen.width >= 951 && screen.width < 985) {
                if (badgeHeight <= 18)
                    badgeHeight = 26;
                else if (badgeHeight > 18 && badgeHeight <= 37)
                    badgeHeight = 46;
                else
                    badgeHeight = 66;
            }
            else if ((screen.width >= 872 && screen.width < 902) || (screen.width >= 779 && screen.width < 834)) {
                if (badgeHeight <= 16)
                    badgeHeight = 26;
                else if (badgeHeight > 16 && badgeHeight <= 27)
                    badgeHeight = 46;
                else if (badgeHeight > 27 && badgeHeight <= 42)
                    badgeHeight = 66;
                else
                    badgeHeight = 86;
            }
            else if (screen.width >= 834 && screen.width < 872) {
                if (badgeHeight <= 15)
                    badgeHeight = 26;
                else if (badgeHeight > 15 && badgeHeight <= 31)
                    badgeHeight = 46;
                else if (badgeHeight > 31 && badgeHeight <= 42)
                    badgeHeight = 66;
                else
                    badgeHeight = 86;
            }
            else {
                if (badgeHeight <= 13)
                    badgeHeight = 26;
                else if (badgeHeight > 13 && badgeHeight <= 26)
                    badgeHeight = 46;
                else if (badgeHeight > 22 && badgeHeight <= 39)
                    badgeHeight = 66;
                else
                    badgeHeight = 86;
            }
        }
    }
    if (device === 'MOBILE') {
        if (window.screen.width === 390 && isMac) {
            if (badgeHeight <= 13)
                badgeHeight = 26;
            else if (badgeHeight > 13 && badgeHeight <= 27)
                badgeHeight = 46;
            else if (badgeHeight > 27 && badgeHeight <= 42)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
        else if (window.screen.width > 320 && window.screen.width < 375) {
            if (badgeHeight <= 11)
                badgeHeight = 26;
            else if (badgeHeight > 11 && badgeHeight <= 23)
                badgeHeight = 46;
            else if (badgeHeight > 23 && badgeHeight <= 36)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
        else if (window.screen.width >= 375 && window.screen.width <= 392) {
            if (badgeHeight <= 14)
                badgeHeight = 26;
            else if (badgeHeight > 14 && badgeHeight <= 24)
                badgeHeight = 46;
            else if (badgeHeight > 24 && badgeHeight <= 45)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
        else if (window.screen.width > 392 && window.screen.width <= 638) {
            if (badgeHeight <= 16)
                badgeHeight = 26;
            else if (badgeHeight > 16 && badgeHeight <= 27)
                badgeHeight = 46;
            else if (badgeHeight > 27 && badgeHeight <= 42)
                badgeHeight = 66;
            else
                badgeHeight = 86;
        }
        else if (window.screen.width > 638 && window.screen.width <= 720) {
            if (badgeHeight <= 27)
                badgeHeight = 26;
            else if (badgeHeight > 27)
                badgeHeight = 46;
        }
    }
    if (device === 'SMALL') {
        if (badgeHeight <= 11)
            badgeHeight = 26;
        else if (badgeHeight > 11 && badgeHeight <= 21)
            badgeHeight = 46;
        else if (badgeHeight > 21 && badgeHeight <= 31)
            badgeHeight = 66;
        else
            badgeHeight = 86;
    }
    return badgeHeight + 4;
};
export const phoneValidation = (val) => {
    const repeatingSeq = /([0-9])\1{8}/;
    if (repeatingSeq.test(val)) {
        return false;
    }
    else {
        return /^[+]?[0-9 ]*$/.test(val);
    }
};
export const replaceThreeDots = (input) => {
    return input.replaceAll('…', '...');
};
export const isIpad = () => {
    const isIpad = /iPad/.test(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || ((navigator === null || navigator === void 0 ? void 0 : navigator.platform) === 'MacIntel' && (navigator === null || navigator === void 0 ? void 0 : navigator.maxTouchPoints) > 1);
    return isIpad;
};
export const paymentTypes = [
    {
        type: PaymentMethodTypes.CARD,
        icons: ['card'],
        description: '',
        buttonLabel: '',
    },
    {
        type: PaymentMethodTypes.PAYPAL,
        icons: ['paypal'],
        description: 'You will be redirected to PayPal to complete your payment.',
        buttonLabel: 'paypalButton350',
    },
    {
        type: PaymentMethodTypes.KLARNA_PAY_SLICED,
        icons: ['klarna'],
        description: `<p>Pay later in 3 interest-free instalments.</p><p>You will be redirected to Klarna to complete your payment.</p>`,
        buttonLabel: 'klarnaButton300x44',
    },
    {
        type: PaymentMethodTypes.KLARNA_PAY_LATER,
        icons: ['klarna'],
        description: `<p>Pay later in 3 interest-free instalments.</p><p>You will be redirected to Klarna to complete your payment.</p>`,
        buttonLabel: 'klarnaButton300x44',
    },
    {
        type: PaymentMethodTypes.KLARNA_PAY_NOW,
        icons: ['klarna'],
        description: `<p>Pay later in 3 interest-free instalments.</p><p>You will be redirected to Klarna to complete your payment.</p>`,
        buttonLabel: 'klarnaButton300x44',
    },
];
export const sizes = [
    {
        breakpoint: 'lg',
        query: 'max-width',
        width: '100vw',
    },
    {
        breakpoint: 'xl',
        query: 'max-width',
        width: '50vw',
    },
    {
        width: '800px',
    },
];
export const imageWidths = [240, 384, 480, 620, 800, 960, 1280];
export const checkIsTablet = () => {
    if (typeof window !== 'undefined') {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent);
    }
    return false;
};
export const handleSuggestedSearchOrPreviousSearch = (peviousSearchValues) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const searchClient = algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID, process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY);
    const index = searchClient.initIndex(`dev_product_uk`);
    const algoliaSearchResults = yield index.search(peviousSearchValues, {
        distinct: true,
        hitsPerPage: 5,
        clickAnalytics: true,
    });
    const match = (_a = algoliaSearchResults === null || algoliaSearchResults === void 0 ? void 0 : algoliaSearchResults.userData) === null || _a === void 0 ? void 0 : _a.find((data) => Boolean(data.redirect));
    return match;
});
export const myAccountSuccessMessages = {
    'communications-preferences': communicationPreferenceUpdateSuccessMessage,
    'change-password-success': updatedPasswordSuccessMessage,
};
const getSingleColumnsSpotlightProducts = (menuSpotLightProduct, firstColumn, secondColumn, thirdColumn, isAllSingleSpotlightBnner) => {
    let spotlightProducts = [];
    if (isAllSingleSpotlightBnner) {
        spotlightProducts = menuSpotLightProduct.slice(0, 3);
    }
    if (((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '1' && (secondColumn === null || secondColumn === void 0 ? void 0 : secondColumn.columnWidth) === '1' && (thirdColumn === null || thirdColumn === void 0 ? void 0 : thirdColumn.columnWidth) === '2') ||
        ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '1' && (secondColumn === null || secondColumn === void 0 ? void 0 : secondColumn.columnWidth) === '2') ||
        ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '2' && (secondColumn === null || secondColumn === void 0 ? void 0 : secondColumn.columnWidth) === '1')) {
        spotlightProducts = menuSpotLightProduct.slice(0, 2);
    }
    if ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '2' && (secondColumn === null || secondColumn === void 0 ? void 0 : secondColumn.columnWidth) === '2') {
        spotlightProducts = menuSpotLightProduct.slice(0, 1);
    }
    if ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '2' && menuSpotLightProduct.length === 1) {
        spotlightProducts = menuSpotLightProduct.slice(0, 1);
    }
    return spotlightProducts;
};
const getTwoColumnsSpotlightProducts = (menuSpotLightProduct, firstColumn, secondColumn, isAllSingleSpotlightBnner) => {
    let spotlightProducts = [];
    if (isAllSingleSpotlightBnner || ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '1' && (secondColumn === null || secondColumn === void 0 ? void 0 : secondColumn.columnWidth) === '1')) {
        spotlightProducts = menuSpotLightProduct.slice(0, 2);
    }
    if (((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '2' && (secondColumn === null || secondColumn === void 0 ? void 0 : secondColumn.columnWidth) === '1') ||
        ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '1' && (secondColumn === null || secondColumn === void 0 ? void 0 : secondColumn.columnWidth) === '2')) {
        spotlightProducts = menuSpotLightProduct.slice(0, 1);
    }
    if ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '2' && menuSpotLightProduct.length === 1) {
        spotlightProducts = menuSpotLightProduct.slice(0, 1);
    }
    return spotlightProducts;
};
const getThreeColumnsSpotlightProducts = (menuSpotLightProduct, firstColumn) => {
    let spotlightProducts = [];
    if ((firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.columnWidth) === '1') {
        spotlightProducts = menuSpotLightProduct.slice(0, 1);
    }
    return spotlightProducts;
};
export const getSpotLightProduct = (linkCols, isAllSingleSpotlightBnner, menuSpotLightProduct) => {
    let spotlightProducts = [];
    const firstColumn = menuSpotLightProduct[0];
    const secondColumn = menuSpotLightProduct[1];
    const thirdColumn = menuSpotLightProduct[2];
    switch (linkCols) {
        case 1:
            spotlightProducts = getSingleColumnsSpotlightProducts(menuSpotLightProduct, firstColumn, secondColumn, thirdColumn, isAllSingleSpotlightBnner);
            break;
        case 2:
            spotlightProducts = getTwoColumnsSpotlightProducts(menuSpotLightProduct, firstColumn, secondColumn, isAllSingleSpotlightBnner);
            break;
        case 3:
            spotlightProducts = getThreeColumnsSpotlightProducts(menuSpotLightProduct, firstColumn);
            break;
        default:
            spotlightProducts = [];
            break;
    }
    return spotlightProducts;
};
/** to get total count for aloglia sepcific indices from the NbHits*/
export const calculateTotalNBHitsCount = (nbHits, algoliaIndexes) => {
    var _a;
    let totalCount = 0;
    for (const nbHit of nbHits) {
        for (const algoliaIndex of algoliaIndexes) {
            const nbHitValue = (_a = nbHit[algoliaIndex]) !== null && _a !== void 0 ? _a : 0;
            totalCount += nbHitValue;
            if (nbHitValue)
                break;
        }
    }
    return totalCount;
};
export const CUSTOM_SIZE = 'Custom size';
export const PDP_MADE_TO_ORDER = 'Made to Order';
/** filtering with secondary badge and sorting with secondary badge length - megnav mobile products */
const sortSecondaryBadgeProducts = (products) => {
    var _a;
    return (_a = products
        .filter((product) => { var _a, _b; return !!((_b = (_a = product.images[0]) === null || _a === void 0 ? void 0 : _a.secondaryBadge) === null || _b === void 0 ? void 0 : _b.title); })) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
        var _a, _b, _c, _d;
        if (!!((_b = (_a = a === null || a === void 0 ? void 0 : a.images[0]) === null || _a === void 0 ? void 0 : _a.secondaryBadge) === null || _b === void 0 ? void 0 : _b.title) && !!((_d = (_c = b === null || b === void 0 ? void 0 : b.images[0]) === null || _c === void 0 ? void 0 : _c.secondaryBadge) === null || _d === void 0 ? void 0 : _d.title)) {
            return a.images[0].secondaryBadge.title.length < b.images[0].secondaryBadge.title.length ? 1 : -1;
        }
        else
            return 1;
    });
};
/** calculate meganav mobile secondary badge length */
export const calculateSecondaryBadgeTitleLength = (products) => {
    var _a, _b, _c, _d;
    const { device } = handleSecondaryBadgeHeight();
    let lengthOfTitle = 0;
    const sortedProducts = sortSecondaryBadgeProducts(products);
    const badgeCharLength = !!(sortedProducts === null || sortedProducts === void 0 ? void 0 : sortedProducts.length) && ((_d = (_c = (_b = (_a = sortedProducts[0]) === null || _a === void 0 ? void 0 : _a.images[0]) === null || _b === void 0 ? void 0 : _b.secondaryBadge) === null || _c === void 0 ? void 0 : _c.title) === null || _d === void 0 ? void 0 : _d.length);
    if (device === 'MOBILE' && !!badgeCharLength) {
        if (badgeCharLength > 18)
            lengthOfTitle = SECONDARY_BADGE_TWO_LINES + 8 + 14;
        else if (badgeCharLength >= 10 && badgeCharLength <= 18)
            lengthOfTitle = SECONDARY_BADGE_SINGLE_LINE_MOBILE + 28 + 14;
        else if (badgeCharLength < 10)
            lengthOfTitle = SECONDARY_BADGE_SINGLE_LINE_MOBILE + 14;
    }
    if (device === 'TABLET' && !!badgeCharLength) {
        if (badgeCharLength > 25)
            lengthOfTitle = 54 + 14;
        else
            lengthOfTitle = SECONDARY_BADGE_SINGLE_LINE_MOBILE + 14;
    }
    return lengthOfTitle;
};
export const TRANSITION_DELAY_DEFAULT = 3000;
export const capitalizeFirstCharacterInWords = (key) => {
    const words = key === null || key === void 0 ? void 0 : key.split('_');
    // Capitalize the first letter of each word
    const capitalizedWords = words.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    const result = capitalizedWords.join('_');
    return result;
};
export const addImportant = (styles) => {
    return Object.fromEntries(Object.entries(styles).map(([key, value]) => {
        return [key, `${value} !important`];
    }));
};
export const formatTime = (timeStr = '1200') => {
    // Extract hour and minute from the time string
    let hours = parseInt(timeStr.slice(0, 2), 10);
    const minutesVal = timeStr.slice(2);
    // Determine AM or PM
    const period = hours >= 12 ? 'pm' : 'am';
    // Convert to 12-hour format
    hours = hours % 12 || 12;
    const minutes = `:${minutesVal}`;
    // Format the final result
    return `${hours}${minutesVal === '00' ? '' : minutes}${period}`.trim();
};
export const getCoordinates = (coordinates) => {
    const latitude = coordinates.length > 0 ? coordinates[0] : '';
    const longitude = coordinates.length > 1 ? coordinates[1] : '';
    return { latitude, longitude };
};
export const getCollectionDay = (date) => {
    if (date) {
        const collectionDate = new Date(date);
        return format(collectionDate, 'EEEE');
    }
    else
        return '';
};
export const isCookieTypeAccepted = (cookieType) => {
    var _a, _b, _c, _d;
    if (typeof window === 'undefined')
        return false;
    const consentCookieRegex = /OptanonConsent/i;
    const consentCookie = (_b = (_a = document === null || document === void 0 ? void 0 : document.cookie) === null || _a === void 0 ? void 0 : _a.split(';')) === null || _b === void 0 ? void 0 : _b.filter((cookie) => consentCookieRegex === null || consentCookieRegex === void 0 ? void 0 : consentCookieRegex.exec(cookie));
    const cookieRegEx = new RegExp(`${cookieType}%3A(\\d+)`);
    const cookieValue = (_d = (_c = cookieRegEx.exec(consentCookie === null || consentCookie === void 0 ? void 0 : consentCookie[0])) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : '';
    return cookieValue === '1';
};
// Usage
export const isPreferenceCookieAccepted = () => isCookieTypeAccepted('C0002');
export const getTextContentPositionClass = (textContentPosition, classNames, defaultPosition) => {
    const textContentPositionClasses = {
        BOTTOM: classNames === null || classNames === void 0 ? void 0 : classNames.positionBottom,
        TOP: classNames === null || classNames === void 0 ? void 0 : classNames.positionTop,
        CENTER: classNames === null || classNames === void 0 ? void 0 : classNames.positionCenter,
    };
    const position = textContentPosition !== null && textContentPosition !== void 0 ? textContentPosition : defaultPosition;
    return textContentPositionClasses[position];
};
export const getTextAlignmentClass = (textPosition, classNames, defaultPosition) => {
    const textAlignmentClass = {
        RIGHT: classNames === null || classNames === void 0 ? void 0 : classNames.textRight,
        LEFT: classNames === null || classNames === void 0 ? void 0 : classNames.textLeft,
        CENTER: classNames === null || classNames === void 0 ? void 0 : classNames.textCenter,
    };
    const textAlignment = textPosition !== null && textPosition !== void 0 ? textPosition : defaultPosition;
    return textAlignmentClass[textAlignment];
};
export const getMobilePositionClass = (mobileContentPosition, classes) => {
    switch (mobileContentPosition === null || mobileContentPosition === void 0 ? void 0 : mobileContentPosition.toUpperCase()) {
        case 'OVER':
            return classes.mobilePositionOver;
        case 'BELOW':
            return classes.mobilePositionBottom;
        default:
            return undefined;
    }
};
export const getContentPositionClass = (contentPosition, classes) => {
    switch (contentPosition === null || contentPosition === void 0 ? void 0 : contentPosition.toUpperCase()) {
        case 'LEFT':
            return classes.positionLeft;
        case 'RIGHT':
            return classes.positionRight;
        case 'CENTER':
            return classes.positionCenter;
        default:
            return undefined;
    }
};
export const getMinHeightClass = (minHeight, classes) => {
    switch (minHeight === null || minHeight === void 0 ? void 0 : minHeight.toUpperCase()) {
        case 'SMALL':
            return classes.minHeightSmall;
        case 'MEDIUM':
            return classes.minHeightMedium;
        case 'LARGE':
            return classes.minHeightLarge;
        case 'BLOG':
            return classes.minHeightBlog;
        default:
            return undefined;
    }
};
